__turbopack_context__.v({
  "cta": "SnackbarAction-module-scss-module__Uwbj2W__cta",
});
